import companyApi from '@/api/company';
import employeeApi from '@/api/companyEmployee';
import departmentApi from '@/api/companyDepartment';
import memberApi from '@/api/companyDepartmentMember';
import popup from '@/model/popup';

export default {
  namespaced: true,
  state: () => ({
    company: null,
    employees: [],
    members: [],
  }),
  getters: {
    // members(state) {
    //   return [
    //     state.project.author,
    //     ...state.project?.projectMembers?.map((m) => m.user),
    //   ];
    // },
    withMembers(state) {
      const roles = {
        head: { name: 'Руководитель', sort: 0 },
        manager: { name: 'Менеджер', sort: 1 },
        member: { name: 'Сотрудник', sort: 2 },
      };

      const membersByDepartmentIri = state.members.reduce((acc, val) => {
        const role = val.role ?? 'member';
        const member = {
          ...val,
          roleName: roles[val.role]?.name,
          sort: roles[val.role]?.sort,
          role,
        }
        const deptId = val.department;
        acc[deptId] ??= [];
        acc[deptId].push(member);
        return acc;
      }, {});

      return {
        ...state.company,
        departments: (state?.company?.departments ?? [])
          .map(d => ({
            ...d,
            members: (membersByDepartmentIri[d['@id']] ?? [])
              .sort((a, b) => a.sort - b.sort),
          }))
      };
    }
  },
  mutations: {
    setCompany(state, company) { state.company = company; },
    setEmployees(state, items) { state.employees = items; },
    setMembers(state, items) { state.members = items; },
  },
  actions: {
    fetch({ state, commit }, { companyId, force }) {
      if (state.company?.id === companyId && !force) return;

      Promise.all([
        companyApi.fetchItem(companyId, {}, true),
        employeeApi.fetchList({ company: companyId }, true),
        memberApi.fetchList({ 'department.company': companyId }, true)
      ]).then(([ rCompany, rEmployees, rMembers ]) => {
        commit('setCompany', rCompany);
        commit('setEmployees', rEmployees.items);
        commit('setMembers', rMembers.items);
      })
    },
    refetch({ dispatch, state }) {
      dispatch('fetch', { companyId: state.company.id, force: true });
    },
    async addEmployees({ state, dispatch }, users) {
      const promises = users.map(user => employeeApi.create({ user, company: state.company['@id'] }, true));
      await Promise.all(promises);
      dispatch('refetch');
    },
    async updateEmployeePosition({ dispatch }, { employee, position }) {
      await employeeApi.update(employee.id, { position }, true);
      dispatch('refetch');
    },
    async deleteEmployee({ dispatch }, employee) {
      await employeeApi.delete(employee.id, true);
      dispatch('refetch');
    },
    async addDepartment({ state, dispatch }, { name }) {
      await departmentApi.create({ name, company: state.company['@id'] }, true);
      dispatch('refetch');
    },
    async updateDepartment({ dispatch }, { id, name }) {
      await departmentApi.update(id, { name }, true);
      dispatch('refetch');
    },
    async deleteDepartment({ dispatch }, { id }) {
      await departmentApi.delete(id, true)
        .then(() => { dispatch('refetch'); })
        .catch(e => {
          const err = e.description === 'Unable to delete department with projects'
            ? 'Невозможно удалить отдел с проектами. Заархивируйте и удалите все проекты, относящиеся к отделу, после чего повторите попытку.'
            : 'Неизвестная ошибка';
          popup.addAlert(err);
        });

    },
    async addMembers({ state, dispatch }, items) {
      const promises = items.map(item => memberApi.create(item, true));
      await Promise.all(promises);
      dispatch('refetch');
    },
    async updateMember({ dispatch }, { id, role }) {
      await memberApi.update(id, { role }, true);
      dispatch('refetch');
    },
    async deleteMember({ dispatch }, { id }) {
      await memberApi.delete(id, true);
      dispatch('refetch');
    },
    async addDeputies({ state, dispatch }, items) {
      const deputyIris = state.company.deputies.map(d => d['@id']);
      const deputies = [...deputyIris, ...items.map(i => i.employee)];
      await companyApi.update(state.company.id, { deputies }, true);
      dispatch('refetch');
    },
    async deleteDeputy({ state, dispatch }, employee) {
      const deputyIris = state.company.deputies.map(d => d['@id']);
      const deputies = deputyIris.filter(d => d !== employee['@id']);
      await companyApi.update(state.company.id, { deputies }, true);
      dispatch('refetch');
    },
  },
};
